var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeStarsCoinMono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3a5 5 0 110 10A5 5 0 018 3zm-2.095 8.407A3.98 3.98 0 008 12a3.98 3.98 0 002.095-.593L8 9.807l-2.096 1.6zM4.161 6.872a4.002 4.002 0 001.505 4.375l.807-2.608L4.16 6.872zM9.527 8.64l.806 2.608a3.993 3.993 0 001.504-4.375L9.527 8.64zm-.583-1.89H11.8a4 4 0 00-3.702-2.747l.847 2.746zm-1.04-2.747a4 4 0 00-3.703 2.746h2.857l.846-2.746z",
    fill: "#fff"
  })));
}
SvgPokerGameTypeStarsCoinMono.displayName = 'PokerGameTypeStarsCoinMono';
export default SvgPokerGameTypeStarsCoinMono;